import React, { useRef, useState } from 'react';

import { Container, Grid, makeStyles, Typography } from '@material-ui/core';

import { ReactComponent as ArrowDown } from '../../assets/images/arrowDown.svg';
import EditFields from '../common/EditFields';

const useStyles = makeStyles((theme) => {
  return {
    caseCount: {
      color: theme.palette.primary.main,
      fontSize: '32px',
      marginRight: '15px',
    },
    caseLabel: {
      color: '#172B4D',
      fontSize: '16px',
    },
    casesTitle: {
      color: '#172B4D',
      fontSize: '16px',
      fontWeight: '500',
      lineHeight: '19px',
    },
    description: {
      marginBottom: '1rem',
    },
    filtersContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      marginBottom: '40px',
      marginTop: '40px',
    },
    formTitle: {
      marginBottom: '1rem',
    },
    headerContainer: {
      borderBottom: '1px solid #E7E7E7',
      paddingBottom: '40px',
      width: '100%',
    },
    headerLabel: {
      color: '#172B4D',
      fontSize: '16px',
    },
    headerNumber: {
      color: theme.palette.primary.main,
      fontSize: '72px',
    },
    mainContainer: {
      display: 'flex',
      flexDirection: 'column',
      marginTop: '40px',
    },
    rotatedIcon: {
      transform: 'rotate(180deg)',
    },
    selectLabels: {
      color: '#172B4D',
      fontSize: '16px',
      fontWeight: '500',
    },
    smallCount: {
      color: theme.palette.primary.main,
      fontSize: '16px',
      fontWeight: '500',
      lineHeight: '19px',
      width: '32px',
    },
    sortBtn: {
      cursor: 'pointer',
    },
    statsContainer: {
      borderRight: '1px solid #E7E7E7',
    },
  };
});

export default ({ filteringStatus }) => {
  const onFilterChange = (values) => {
    // update data based on filters
    console.log(values);
  };

  const [completeSorting, setCompleteSorting] = useState('desc');
  const [skippedSorting, setSkippedSorting] = useState('asc');
  const fields = [
    { items: [{ label: 'All', value: 'all' }], label: 'Clinic', labelPosition: 'top', name: 'clinic', onChange: onFilterChange, type: 'select', width: '45%' },
    { items: [{ label: 'October 2020', value: 1 }], label: 'Currently viewing', labelPosition: 'top', name: 'date', onChange: onFilterChange, type: 'select', width: '45%' },
  ];
  const defaultData = { clinic: 'all', date: 1 };
  const classes = useStyles();
  const editFieldRef = useRef();
  const renderHeaderValues = () => (
    <Grid item container xs={8} style={{ paddingLeft: '80px' }}>
      <Grid item xs={4} direction="column">
        <Typography variant="h4" className={classes.headerNumber} align="left">
          436
        </Typography>
        <Typography variant="h4" className={classes.headerLabel} align="left">
          Mediphany Patients
        </Typography>
      </Grid>
      <Grid item xs={4} direction="column">
        <Typography variant="h4" className={classes.headerNumber} align="left">
          436
        </Typography>
        <Typography variant="h4" className={classes.headerLabel} align="left">
          Mediphany Patients
        </Typography>
      </Grid>
      <Grid item xs={4} direction="column">
        <Typography variant="h4" className={classes.headerNumber} align="left">
          436
        </Typography>
        <Typography variant="h4" className={classes.headerLabel} align="left">
          Mediphany Patients
        </Typography>
      </Grid>
    </Grid>
  );

  const renderHeader = () => (
    <div>
      <Grid container className={classes.headerContainer}>
        <Grid item component="div" xs={4} style={{ paddingRight: '80px' }}>
          <Typography variant="h4" className={classes.formTitle} align="left">
            Analytics
          </Typography>
          <Typography variant="subtitle1" className={classes.description} align="left">
            Some content describing that analytics are based on all workspaces created by the super administrator
          </Typography>
        </Grid>
        {renderHeaderValues()}
      </Grid>
    </div>
  );

  const renderFilters = () => (
    <div>
      <Grid container>
        <Grid item xs={6} className={classes.filtersContainer}>
          <EditFields data={defaultData} fields={fields} useLabel ref={editFieldRef} labelPosition="top" labelClass={classes.selectLabels} />
        </Grid>
      </Grid>
    </div>
  );

  const renderStats = () => {
    const caseCounts = [
      {
        count: 689,
        label: 'Total Cases Completed',
      },
      {
        count: 456,
        label: 'New Cases Submitted',
      },
      {
        count: 689,
        label: 'Clinic Cases Completed',
      },
      {
        count: 689,
        label: 'Mediphany Cases completed',
      },
      {
        count: 689,
        label: 'Cases assigned to Mediphany',
      },
    ];
    const completedCases = [
      {
        count: 24,
        label: 'Gavin Breeds',
      },
      {
        count: 18,
        label: 'Jeremy Dyssell',
      },
      {
        count: 14,
        label: 'Henry Benjamin Hartzenberg',
      },
      {
        count: 12,
        label: 'Ajesh Shaun Janki',
      },
      {
        count: 8,
        label: 'Faizel Lorgat',
      },
    ];
    const skippedCases = [
      {
        count: 24,
        label: 'Gavin Breeds',
      },
      {
        count: 18,
        label: 'Jeremy Dyssell',
      },
      {
        count: 14,
        label: 'Henry Benjamin Hartzenberg',
      },
      {
        count: 12,
        label: 'Ajesh Shaun Janki',
      },
      {
        count: 8,
        label: 'Faizel Lorgat',
      },
    ];
    const renderTotalCases = () =>
      caseCounts.map((count) => (
        <Grid container alignItems="center" className="mb-1">
          <Typography variant="h4" className={classes.caseCount} align="left">
            {count.count}
          </Typography>
          <Typography variant="body1" className={classes.caseLabel} align="left">
            {count.label}
          </Typography>
        </Grid>
      ));

    const renderCases = (cases) => {
      return cases.map((_case) => (
        <Grid container alignItems="center" className="mb-1">
          <Typography variant="h4" className={classes.smallCount} align="left">
            {_case.count}
          </Typography>
          <Typography variant="body1" className={classes.caseLabel} align="left">
            {_case.label}
          </Typography>
        </Grid>
      ));
    };

    return (
      <Grid container>
        <Grid container item xs={10}>
          <Grid item xs={4} className={classes.statsContainer}>
            {renderTotalCases()}
          </Grid>
          <Grid item xs={4} className="pl-1 right-separator">
            <Grid container alignItems="center">
              <Grid item className="mr-1">
                <Typography className={classes.caseTitle}>Completed Cases</Typography>
              </Grid>

              <Grid item>
                <ArrowDown className={`${classes.sortBtn} ${completeSorting === 'desc' ? '' : classes.rotatedIcon}`} />
              </Grid>
            </Grid>
            <Grid container alignItems="center" className="mt-1">
              {renderCases(completedCases)}
            </Grid>
          </Grid>
          <Grid item xs={4} className="pl-1">
            <Grid container alignItems="center">
              <Grid item className="mr-1">
                <Typography className={classes.caseTitle}>Completed Cases</Typography>
              </Grid>

              <Grid item>
                <ArrowDown className={`${classes.sortBtn} ${skippedSorting === 'desc' ? '' : classes.rotatedIcon}`} />
              </Grid>
            </Grid>
            <Grid container alignItems="center" className="mt-1">
              {renderCases(skippedCases)}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    );
  };

  return (
    <Container component="main" maxWidth="lg" className={classes.mainContainer}>
      {renderHeader()}
      {renderFilters()}
      {renderStats()}
    </Container>
  );
};
